import { Component, HostListener, OnInit } from "@angular/core";
import { CurrencyPipe, formatDate } from "@angular/common";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { Order } from "src/app/core/entities/order";
import { Configuracoes } from "src/app/core/entities/configuracoes";
import { PedidoService } from "src/app/core/services/pedido-service";
import { RelatorioService } from "src/app/core/services/relatorios.service";
import { UsuarioService } from "src/app/core/services/usuario-service";
import { Router, ActivatedRoute } from "@angular/router";

declare var $: any;

type ChipStatus = string;

@Component({
  selector: "app-pedidos-em-andamento",
  templateUrl: "./pedidos-em-andamento.component.html",
  styleUrls: ["./pedidos-em-andamento.component.css"],
})
export class PedidosEmAndamentoComponent implements OnInit {
  public pedidos: Order[] = [];
  public pedido: any;
  public empty = false;
  public loading = false;
  public loadNota = false;
  public pagando: any = null;
  public visualizando: any = null;
  public transacao: any = null;
  public metodoPagamento: "cartao" | "pix" | "link" = "link";
  public linkCopiado = false;
  public formSearch: FormGroup;
  public searchTerm = "";
  public buscaClientes: any[] = [];
  public buscandoCliente = false;
  public clienteFiltro: number | null = null;
  public clienteNomeSelecionado = "";
  public pedidoFiltro = "";
  public selectedPeriod = "30d";
  public statusFiltro: ChipStatus = "TODOS";
  public totaisStatus: Record<string, number> = {};
  public page = 1;
  public totalPages = 0;
  public totalElements = 0;
  public primaryColor = "#6d1b7b";

  private currencyPipe = new CurrencyPipe("pt-BR");
  private detalheCache = new Map<string, any>();
  private detalhePending = new Map<string, Array<(detalhe: any) => void>>();
  loadGeraLink: boolean = false;

  constructor(
    private pedidoService: PedidoService,
    private router: Router,
    private relatorioService: RelatorioService,
    private usuarioService: UsuarioService,
    private formBuilder: FormBuilder,
    private toastService: ToastrService
  ) {
    this.primaryColor =
      Configuracoes.SITE?.backgroundColorSliderSuperior || this.primaryColor;
    this.formSearch = this.formBuilder.group({
      pedido: [""],
    });
  }

  ngOnInit() {
    this.loadPedidos();
  }

  get lista(): Order[] {
    return this.pedidos;
  }

  get chips(): { id: ChipStatus; label: string; count: number }[] {
    const totais = this.totaisStatus || {};
    const extras = Object.keys(totais)
      .filter((k) => k && k.toUpperCase() !== "TODOS")
      .sort((a, b) => a.localeCompare(b, "pt-BR"));
    const totalGeral = extras.reduce((acc, k) => acc + (Number(totais[k]) || 0), 0);
    return [
      { id: "TODOS", label: "Todos", count: totalGeral },
      ...extras.map((s) => ({
        id: String(s).toUpperCase(),
        label: this.labelStatus(s),
        count: Number(totais[s]) || 0,
      })),
    ];
  }

  get visiblePages(): number[] {
    const maxVisible = 5;
    if (!this.totalPages) return [];
    let start = Math.max(1, this.page - Math.floor(maxVisible / 2));
    let end = start + maxVisible - 1;
    if (end > this.totalPages) {
      end = this.totalPages;
      start = Math.max(1, end - maxVisible + 1);
    }
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  }

  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent) {
    const alvo = event.target as HTMLElement;
    if (!alvo?.closest(".pea-busca")) {
      this.fecharBuscaClientes();
    }
  }

  fecharBuscaClientes() {
    this.buscaClientes = [];
    this.buscandoCliente = false;
  }

  limparFiltroBusca() {
    this.searchTerm = "";
    this.clienteFiltro = null;
    this.clienteNomeSelecionado = "";
    this.pedidoFiltro = "";
    this.formSearch.controls.pedido.setValue("");
    this.fecharBuscaClientes();
  }

  limparCliente(event?: Event) {
    event?.preventDefault();
    event?.stopPropagation();
    this.limparFiltroBusca();
    this.loadPedidos(1);
  }

  onSearch() {
    const termo = (this.searchTerm || "").trim();
    this.fecharBuscaClientes();

    if (this.clienteFiltro && termo === this.clienteNomeSelecionado) {
      this.loadPedidos(1);
      return;
    }

    this.clienteFiltro = null;
    this.clienteNomeSelecionado = "";
    this.pedidoFiltro = "";
    this.formSearch.controls.pedido.setValue("");

    if (!termo) {
      this.loadPedidos(1);
      return;
    }

    const numero = termo.replace(/^#/, "");
    if (/^\d+$/.test(numero)) {
      this.pedidoFiltro = numero;
      this.formSearch.controls.pedido.setValue(numero);
      this.loadPedidos(1);
      return;
    }

    this.buscandoCliente = true;
    this.usuarioService.post(
      "usuario/getBuscaCliente",
      { busca: termo },
      (resp) => {
        const lista = Array.isArray(resp)
          ? resp
          : resp?.content || resp?.data || [];
        this.buscaClientes = lista;
        this.buscandoCliente = false;
        if (!lista.length) {
          this.toastService.warning($localize`Nenhum cliente encontrado`);
        }
      },
      () => {
        this.buscandoCliente = false;
        this.toastService.warning($localize`Não foi possível buscar o cliente`);
      }
    );
  }

  selecionarClienteBusca(cliente: any) {
    const id = Number(cliente?.id);
    if (!id) {
      this.toastService.warning($localize`Cliente sem identificador`);
      return;
    }
    this.clienteFiltro = id;
    this.clienteNomeSelecionado = [this.docClienteBusca(cliente), this.nomeClienteBusca(cliente)]
      .filter(Boolean)
      .join(" - ");
    this.pedidoFiltro = "";
    this.searchTerm = this.clienteNomeSelecionado;
    this.fecharBuscaClientes();
    this.loadPedidos(1);
  }

  nomeClienteBusca(c: any): string {
    return c?.nome || c?.fantasia || c?.razaoSocial || c?.clientefantasia || "Cliente";
  }

  docClienteBusca(c: any): string {
    return (
      c?.cnpj ||
      c?.documento ||
      c?.cpfCnpj ||
      c?.clientedocumento ||
      ""
    );
  }

  onPeriodChange() {
    this.loadPedidos(1);
  }

  trackChip(_index: number, chip: { id: ChipStatus }): string {
    return chip.id;
  }

  ehStatusAtivo(status: ChipStatus): boolean {
    return this.normalizarStatusPedido(this.statusFiltro) === this.normalizarStatusPedido(status);
  }

  filtrarStatus(status: ChipStatus) {
    const selecionado = this.normalizarStatusPedido(status);
    if (selecionado === "TODOS") {
      this.limparFiltroBusca();
    }
    this.statusFiltro = selecionado;
    this.page = 1;
    this.totalPages = 0;
    this.loadPedidos(1);
  }

  filtrarStatusDoCard(p: Order) {
    this.filtrarStatus(this.statusPedidoDoCard(p));
  }

  loadPedidos(page: number = 1) {
    this.loading = true;
    if (page < 1) page = 1;
    if (page > this.totalPages && this.totalPages > 0) page = this.totalPages;
    this.page = page;

    const form: any = {
      page: page - 1,
      status_pedido: this.normalizarStatusPedido(this.statusFiltro),
    };
    this.applyPeriodFilter(form);
    if (this.clienteFiltro) {
      form.cliente = this.clienteFiltro;
    }
    if (this.pedidoFiltro) {
      form.pedido = this.pedidoFiltro;
    }

    this.pedidoService.listaPedidoClienteV2(
      form,
      (resp) => {
        this.pedidos = resp.content || [];
        this.totalPages = resp.totalPages;
        this.totalElements = resp.totalElements;
        this.totaisStatus = resp.totais_status || {};
        this.empty = resp.empty === true || this.pedidos.length === 0;
        this.loading = false;
      },
      () => {
        this.empty = true;
        this.loading = false;
      }
    );
  }

  redirectToRastreio(p: Order) {
    this.carregarDetalhe(p, (detalhe) => {
      const rastreio = detalhe?.freteRastreios?.length
        ? detalhe.freteRastreios[0].rastreio
        : null;
      if (rastreio) {
        window.open(rastreio, "_blank")?.focus();
      } else {
        this.toastService.warning($localize`Sem rastreio associado ao pedido`);
      }
    });
  }

  showPedido(p: Order) {
    this.carregarDetalhe(p, (detalhe) => {
      this.visualizando = detalhe;
    });
  }

  fecharVisualizacao() {
    this.visualizando = null;
  }

  showPedidoFinalizado(p: any) {
    this.carregarDetalhe(p, () => {
      $("#pedidoModalInfoAndamento").modal("show");
    });
  }

  showNotaFiscal(p: Order) {
    this.carregarDetalhe(p, () => {
      $("#notaFiscalModalAndamento").modal("show");
    });
  }

  printNota(nota: any) {
    if (!nota || !nota.id) return;
    const headers = new Headers({
      Branch: Configuracoes.API_BRANCH,
      Authorization: "Bearer " + window.localStorage.getItem("token"),
    });

    if (nota.tipo === "danfe") {
      this.loadNota = true;
      fetch(
        `${Configuracoes.API}impressoes/documento?id_documento=${nota.id}`,
        { method: "GET", headers }
      )
        .then((response) => response.text())
        .then((jsonResposta) => {
          this.relatorioService.getDanfePdf(
            jsonResposta,
            (pdf) => {
              window.open(pdf.arquivo);
              this.loadNota = false;
            },
            () => {
              this.loadNota = false;
            }
          );
        })
        .catch(() => {
          this.loadNota = false;
        });
      return;
    }

    this.loadNota = true;
    fetch(`${Configuracoes.API}impressoes/documento?id_documento=${nota.id}`, {
      method: "GET",
      headers,
    })
      .then((response) => response.text())
      .then((xml) => {
        const blob = new Blob([xml], { type: "application/xml" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${nota.numero_nota}.xml`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        this.loadNota = false;
      })
      .catch(() => {
        this.loadNota = false;
      });
  }

  abrirPagamento(p: Order) {
    const id = this.idPedidoCliente(p);
    if (!id) {
      this.toastService.warning($localize`Identificador do pedido não encontrado`);
      return;
    }
    this.pedidoService.criarPagamentoPedido(
      id,
      { tipo_transacao: "link_pagamento" },
      (resp) => {
        this.pagando = {
          ...p,
          transacao: this.normalizarRespostaTransacao(resp),
        };
        this.transacao = this.transacaoDoPedido(this.pagando);
        this.metodoPagamento = this.normalizarTipoPagamento(
          this.transacao?.tipo_pagamento
        );
        this.linkCopiado = false;
      },
      (error) => {
        const mensagem =
          error?.error?.detail || $localize`Não foi possível gerar o pagamento`;
        this.toastService.error(mensagem, $localize`Pedido`);
      }
    );
  }

  private normalizarRespostaTransacao(resp: any): any[] {
    if (!resp) {
      return [];
    }
    if (Array.isArray(resp.transacao)) {
      return resp.transacao;
    }
    if (Array.isArray(resp)) {
      return resp;
    }
    if (resp.tipo_pagamento || resp.link_pagamento) {
      return [resp];
    }
    return [];
  }

  fecharPagamento() {
    this.pagando = null;
    this.transacao = null;
    this.linkCopiado = false;
  }

  metodoHabilitado(metodo: "cartao" | "pix" | "link"): boolean {
    return this.metodoPagamento === metodo;
  }

  copiarPagamento(texto: string) {
    this.copyLink(texto);
    this.linkCopiado = true;
    setTimeout(() => {
      this.linkCopiado = false;
    }, 2000);
  }

  get numeroPedidoPagando(): string {
    const p = this.pagando;
    return String(p?.numero_pedido || p?.id || "");
  }

  get valorPagamento(): number {
    const valor = this.transacao?.valor;
    if (valor !== null && valor !== undefined && valor !== "") {
      return Number(valor);
    }
    return Number(this.pagando?.total) || 0;
  }

  get linkPagamento(): string {
    return this.transacao?.link_pagamento || "";
  }

  get pixCodigo(): string {
    const qr = this.transacao?.qrcode;
    if (!qr || this.isQrImagem(qr)) {
      return "";
    }
    return String(qr);
  }

  get pixImagem(): string {
    const qr = this.transacao?.qrcode;
    if (!this.isQrImagem(qr)) {
      return "";
    }
    return String(qr).startsWith("data:")
      ? String(qr)
      : "data:image/png;base64," + qr;
  }

  private transacaoDoPedido(detalhe: any): any {
    const lista = detalhe?.transacao;
    if (!Array.isArray(lista) || !lista.length) {
      return null;
    }
    return (
      lista.find(
        (t) => String(t?.status || "").toLowerCase() === "pendente"
      ) || lista[0]
    );
  }

  private normalizarTipoPagamento(tipo: any): "cartao" | "pix" | "link" {
    const v = String(tipo || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
    if (v.includes("pix")) {
      return "pix";
    }
    if (v.includes("cart") || v.includes("card")) {
      return "cartao";
    }
    return "link";
  }

  private isQrImagem(qr: any): boolean {
    if (!qr || typeof qr !== "string") {
      return false;
    }
    return (
      qr.startsWith("data:image") ||
      (qr.length > 80 && !qr.startsWith("000201") && !qr.startsWith("http"))
    );
  }

  copyLink(link: string) {
    if (!link) return;
    navigator.clipboard.writeText(link).then(
      () => {
        this.toastService.success(
          $localize`Link copiado com sucesso para a área de transferência`,
          $localize`Pagamento`,
          { positionClass: "toast-bottom-left" }
        );
      },
      () => {
        this.toastService.warning(
          $localize`Erro ao copiar link para a área de transferência`,
          $localize`Pagamento`,
          { positionClass: "toast-bottom-left" }
        );
      }
    );
  }

  formatValor(valor: number): string {
    return (
      this.currencyPipe.transform(valor, "BRL", "symbol", "1.2-2") || "R$ 0,00"
    );
  }

  getClienteNome(p: Order): string {
    const cliente = this.clienteDoPedido(p);
    return cliente?.nome || cliente?.razaoSocial || cliente?.fantasia || "—";
  }

  getClienteCnpj(p: Order): string {
    const cliente = this.clienteDoPedido(p);
    return (
      cliente?.cnpj ||
      cliente?.cpfCnpj ||
      cliente?.documento ||
      cliente?.cgc ||
      ""
    );
  }

  getDestino(p: Order): string {
    const cliente = this.clienteDoPedido(p);
    const cidade = cliente?.cidade || cliente?.cidades;
    if (!cidade) return "—";
    const nome = cidade.nome || cidade.nomecidade || cidade.descricao || "";
    const uf = cidade.uf || cidade.estado || "";
    return [nome, uf].filter(Boolean).join(", ") || "—";
  }

  getTipoPedido(p: Order): string {
    const tipo = p.tipo;
    if (!tipo) return "—";
    const codigo = tipo.codigo || tipo.id || "";
    const descricao = tipo.descricao || tipo.nome || "";
    return [codigo, descricao].filter(Boolean).join(" - ") || "—";
  }

  getStatusPedido(p: Order): string {
    if (p.infos && p.infos.length > 0) {
      return p.infos[p.infos.length - 1].statusDescricao || "Processando";
    }
    return (p as any).statusDescricao || p.status || "Processando";
  }

  statusQuebraLinha(status: any): string {
    return String(status || "").replace(/_/g, "\n");
  }

  getPagamento(p: Order): string {
    return p.formaPagamento?.descricao || "Processando";
  }

  getQtdItens(p: Order): number {
    if (p?.quantidade) return p.quantidade;
    if (p?.itens?.length) {
      return p.itens.reduce((acc, i) => acc + (Number(i.quantidade) || 0), 0);
    }
    return 0;
  }

  get itensVisualizacao(): { codigo: string; descricao: string; itens: any[] }[] {
    const itens = this.visualizando?.itens;
    if (!Array.isArray(itens) || !itens.length) {
      return [];
    }
    const agrupado: Record<string, any[]> = {};
    itens.forEach((item) => {
      const key = String(
        item.produtoReferencia ||
          item.produtoreferencia ||
          item.codigo ||
          item.produto ||
          "item"
      );
      if (!agrupado[key]) {
        agrupado[key] = [];
      }
      agrupado[key].push(item);
    });
    return Object.keys(agrupado).map((key) => ({
      codigo: key === "item" ? "" : key,
      descricao:
        agrupado[key][0]?.produtoDescricao ||
        agrupado[key][0]?.descricao ||
        "",
      itens: agrupado[key],
    }));
  }

  tituloItemGrupo(grupo: { codigo: string; descricao: string }): string {
    return [grupo.codigo, grupo.descricao].filter(Boolean).join(" - ") || "Item";
  }

  corItem(item: any): string {
    return item?.descricao_cor || item?.corDescricao || item?.cor || "—";
  }

  tamanhoItem(item: any): string {
    return (
      item?.descricao_tamanho || item?.tamanhoDescricao || item?.tamanho || "—"
    );
  }

  totalItem(item: any): number {
    if (item?.total != null && item?.total !== "") {
      return Number(item.total);
    }
    return Number(item?.quantidade || 0) * Number(item?.preco || 0);
  }

  somaQtd(itens: any[]): number {
    return (itens || []).reduce(
      (acc, item) => acc + (Number(item?.quantidade) || 0),
      0
    );
  }

  somaTotal(itens: any[]): number {
    return (itens || []).reduce((acc, item) => acc + this.totalItem(item), 0);
  }

  getEmpresaNome(p: any): string {
    const filial = p?.filial;
    if (!filial) {
      return Configuracoes.SITE?.title || "—";
    }
    if (typeof filial === "string") {
      return filial;
    }
    return (
      [filial.codigo, filial.descricao || filial.nome]
        .filter(Boolean)
        .join(" - ") || "—"
    );
  }

  getEmpresaSub(p: any): string {
    const cidade = p?.filial?.cidade;
    if (!cidade) {
      return "";
    }
    return [cidade.nome, cidade.uf].filter(Boolean).join(" - ");
  }

  statusExibicao(p: any): string {
    return this.labelStatus(this.getStatusPedido(p));
  }

  getTabelaPreco(p: any): string {
    const tabela = p?.tabela;
    if (!tabela) {
      return "—";
    }
    if (typeof tabela === "string") {
      return tabela;
    }
    return (
      [tabela.codigo, tabela.descricao || tabela.nome]
        .filter(Boolean)
        .join(" - ") || "—"
    );
  }

  getDataEntrega(p: any): string {
    return p?.dataEntrega || p?.data_entrega || "—";
  }

  getDescontoPercent(p: any): string {
    const cliente = Array.isArray(p?.clientes) ? p.clientes[0] : null;
    const valor = Number(
      cliente?.descontoPercent ?? p?.descontoPercent ?? p?.desconto_percentual ?? 0
    );
    return valor.toFixed(2).replace(".", ",") + " %";
  }

  getPedidoOrigem(p: any): string {
    return p?.pedido_origem || p?.pedidoOrigem || "—";
  }

  getFormaPagamentoCompleta(p: any): string {
    const fp = p?.formaPagamento;
    if (!fp) {
      return "—";
    }
    return [fp.codigo, fp.descricao].filter(Boolean).join(" - ") || "—";
  }

  getSubtotal(p: any): number {
    if (p?.subtotal != null && p?.subtotal !== "") {
      return Number(p.subtotal);
    }
    return Number(p?.total || 0) - this.getImpostos(p);
  }

  getImpostos(p: any): number {
    return Number(p?.impostos ?? p?.imposto ?? 0);
  }
  
    getFreteValor(p: any): number {
    return Number(p?.freteValor ?? 0);
  }

  podePagar(p: Order): boolean {
    if (this.isCancelado(p)) {
      return false;
    }
    return this.isPrePago(p);
  }

  private isPrePago(p: any): boolean {
    const bruto = String(p?.status_pagamento ?? p?.statusPagamento ?? "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[_ ]+/g, "-");
    return bruto === "pre-pago" || bruto === "prepago"|| bruto === "pendente";
  }

  private isCancelado(p: any): boolean {
    const status = String(p?.status || this.getStatusPedido(p) || "").toUpperCase();
    return status === "CANCELADO" || status.includes("CANCEL");
  }

  classeStatus(status: string): string {
    const s = (status || "").toLowerCase();
    if (s.includes("cancel")) return "st-danger";
    if (s.includes("entreg")) return "st-ok";
    if (s.includes("enviad") || s.includes("transito") || s.includes("trânsito")) {
      return "st-primary";
    }
    if (s.includes("aguard") || s.includes("pagament") || s.includes("pend")) {
      return "st-warn";
    }
    if (s.includes("aprov")) return "st-info";
    return "st-muted";
  }

  private clienteDoPedido(p: Order): any {
    if (p.clientes && p.clientes.length > 0) {
      return p.clientes[0].cliente;
    }
    return p.cliente;
  }

  private idPedidoCliente(p: any): any {
    return p?.pedido_cliente_id || p?.pedido || p?.id;
  }

  private carregarDetalhe(p: Order, onOk: (detalhe: any) => void) {
    const id = this.idPedidoCliente(p);
    if (!id) {
      this.toastService.warning($localize`Identificador do pedido não encontrado`);
      return;
    }
    const chave = String(id);
    const cached = this.detalheCache.get(chave);
    if (cached) {
      this.pedido = cached;
      onOk(cached);
      return;
    }
    const fila = this.detalhePending.get(chave);
    if (fila) {
      fila.push(onOk);
      return;
    }
    this.detalhePending.set(chave, [onOk]);
    this.pedidoService.getPedidoClienteV2(
      id,
      (detalhe) => {
        const merged = { ...p, ...detalhe };
        this.detalheCache.set(chave, merged);
        this.pedido = merged;
        const callbacks = this.detalhePending.get(chave) || [];
        this.detalhePending.delete(chave);
        callbacks.forEach((cb) => cb(merged));
      },
      (error) => {
        this.detalhePending.delete(chave);
        const mensagem =
          error?.error?.detail || $localize`Não foi possível carregar o pedido`;
        this.toastService.error(mensagem, $localize`Pedido`);
      }
    );
  }

  private normalizarStatusPedido(status: any): string {
    const bruto = String(status || "TODOS")
      .trim()
      .toUpperCase()
      .replace(/\s+/g, "_");
    if (!bruto || bruto === "TODOS") {
      return "TODOS";
    }
    if (bruto.includes("CANCEL")) {
      return "CANCELADO";
    }
    if (bruto.includes("AGUARD")) {
      return "AGUARDANDO";
    }
    if (bruto.includes("ANDAMENTO")) {
      return "EM_ANDAMENTO";
    }
    return bruto;
  }

  statusPedidoDoCard(p: any): string {
    return this.normalizarStatusPedido(p?.status || this.getStatusPedido(p));
  }

  private labelStatus(status: string): string {
    const mapa: Record<string, string> = {
      AGUARDANDO: "Aguardando",
      CANCELADO: "Cancelado",
      EM_ANDAMENTO: "Em andamento",
    };
    if (mapa[status]) {
      return mapa[status];
    }
    return String(status || "")
      .toLowerCase()
      .replace(/_/g, " ")
      .replace(/(^|\s)\S/g, (s) => s.toUpperCase());
  }

  private applyPeriodFilter(form: any) {
    const hoje = new Date();
    const inicio = new Date();
    if (this.selectedPeriod === "30d") {
      inicio.setDate(hoje.getDate() - 30);
    } else if (this.selectedPeriod === "6m") {
      inicio.setMonth(hoje.getMonth() - 6);
    } else if (this.selectedPeriod === "1a") {
      inicio.setFullYear(hoje.getFullYear() - 1);
    } else {
      inicio.setMonth(hoje.getMonth() - 3);
    }
    form.dataInicial = formatDate(inicio, "dd/MM/yyyy", "en");
    form.dataFinal = formatDate(hoje, "dd/MM/yyyy", "en");
  }
  
   gerarLinkPagamento(p) {
    const id = p.pedido_cliente_id || p.pedido || p.id;
    if (!id) {
      this.toastService.warning($localize`Identificador do pedido não encontrado`);
      return;
    }
    this.loadGeraLink = true;
    this.pedidoService.criarPagamentoPedido(
      id,
      { tipo_transacao: "link_pagamento" },
      (resp) => {
        this.loadGeraLink = false;
        this.pagando = {
          ...p,
          transacao: this.normalizarRespostaTransacao(resp),
        };
      },
      (error) => {
        this.loadGeraLink = false;
        const mensagem =
          error?.error?.detail || $localize`Não foi possível gerar o pagamento`;
        this.toastService.error(mensagem, $localize`Pedido`);
        if (error?.status === 403) {
          this.router.navigate(["/login"]).then(() => {
            window.location.reload();
          });
        }
      }
    );
  }

}
